import { Ref, forwardRef } from 'react'

import { CollectionPageContents_collection_creator } from 'globalTypes'

import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'
import Image from 'next/image'
import Link from 'next/link'

import styles from './index.module.css'

type UserBioProps = {
  creator: CollectionPageContents_collection_creator
}

const Avatar = ({ url, vanity_name }) => {
  return (
    <Link
      className={styles.avatarWrapper}
      href={`/profile/${vanity_name}`}
      passHref
    >
      <Image src={url} alt={url} className="rounded-full object-cover" fill />
    </Link>
  )
}

const BioHead = ({ userName, userAvatar, profileName }) => (
  <div className={styles.headWrapper}>
    <Avatar url={userAvatar} vanity_name={profileName} />

    <div className={styles.headTextWrapper}>
      <Title size="S">
        <Link href={`/profile/${profileName}`} passHref>
          <u className="text-brand-main cursor-pointer">{userName}</u>
        </Link>
      </Title>
    </div>
  </div>
)

const UserBio = forwardRef(function UserBio(
  { creator }: UserBioProps,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div ref={ref} id="user-bio" className={styles.bioWrapper}>
      <BioHead
        userName={creator.brandName ?? creator.name}
        userAvatar={creator.brandLogoSmall ?? creator.picture}
        profileName={creator.vanity_name}
      />
      <Paragraph>{creator.bio}</Paragraph>
    </div>
  )
})

export default UserBio
